(ns app.front.view.group.admin.fees.receipt.template
  (:require [app.domain.fee.model :as fee-model]
            [app.front.entities :as entities]
            [app.front.file.download :as file-download]
            [app.front.ui :as ui]
            [app.front.ui.template-editor :as template-editor]
            [app.front.ui.text-editor :as text-editor]
            [app.front.view.group.admin.subs :as gas]
            [clojure.set :as set]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [re-frame.core-instrumented :as rf])
  (:require-macros [core.util.util :as util]))


(defn do-save [data]
  {:comm/command {:command    :fee/save-receipt-template
                  :method     :post
                  :notify     {:success :receipt/template-saved}
                  :on-success [::save-success]
                  :data       data}})

(rf/reg-event-fx ::save-success
  (fn [_ [_ status db-changes]]
    {:dispatch-n [[::entities/apply-changes status db-changes]]}))

(rf/reg-event-fx ::save
  (fn [_ [_ authority-group-id template-id html css]]
    (do-save (util/mmap authority-group-id
                        template-id
                        html
                        css))))

(rf/reg-event-fx ::save-fee-group
  (fn [_ [_ authority-group-id template-id fee-group-snippet]]
    (do-save (util/mmap authority-group-id
                        template-id
                        fee-group-snippet))))

(rf/reg-event-fx ::save-fee-item
  (fn [_ [_ authority-group-id template-id fee-item-snippet]]
    (do-save (util/mmap authority-group-id
                        template-id
                        fee-item-snippet))))

(rf/reg-sub ::has-multiple-languages?
  :<- [::gas/allowed-locales]
  (fn [locales _]
    (-> locales count (> 1))))

(defn view [tr group-id template inherited? replace-template]
  (let [{:keys
         [:receipt-template/html-template
          :receipt-template/print-css
          :receipt-template/fee-group-html-snippet
          :receipt-template/fee-item-html-snippet]} template
        images                                      (<sub [::gas/verdict-images group-id])
        template-id                                 (:db/id template)
        cheque-number-enabled?                      (<sub [::ff/enabled? :feature-flag.id/add-cheque-number])
        lang                                        (<sub [:language])
        licensing?                                  (<sub [::gas/has-permit-type? #{:permit-type/L}])
        inapplicable-placeholders                   (set/union
                                                      (cond
                                                        (not cheque-number-enabled?) #{"cheque-number" "check-number"}
                                                        (not= lang :en-us) #{"check-number"}
                                                        (= lang :en-us) #{"cheque-number"})
                                                      (when-not licensing? #{"licence-number"})
                                                      #{"gl-code-column-class"})]
    [template-editor/editor
     (-> {:html-template    html-template
          :read-only?       inherited?
          :replace-template replace-template
          :print-css        print-css
          :tr               tr
          :on-save          #(>evt [::save group-id template-id %1 %2])
          :title            [:h3 (tr [(:receipt-template/subtype template)])]
          :preview-url      (file-download/download-href
                              :group/generate-receipt-template-preview-pdf
                              {:group-id    group-id
                               :template-id template-id})
          :placeholders     (remove inapplicable-placeholders
                                    (fee-model/receipt-picker-variables (<sub [::ff/enabled-flags])))
          :images           images}
         (text-editor/with-external-edit-state ::main))
     [:div
      (when (<sub [::has-multiple-languages?])
        [ui/help (tr [:group-locales/multiple-locales-template-help])])
      [template-editor/editor
       (-> {:html-template fee-group-html-snippet
            :read-only?    inherited?
            :html-only?    true
            :tr            tr
            :title         [:h4 (tr [:receipt/fee-group-snippet])]
            :on-save       #(>evt [::save-fee-group group-id template-id %])
            :placeholders  fee-model/fee-group-snippet-variables
            :images        images
            :small?        true}
           (text-editor/with-external-edit-state ::group))
       [template-editor/editor
        (-> {:html-template fee-item-html-snippet
             :read-only?    inherited?
             :tr            tr
             :html-only?    true
             :title         [:h4 (tr [:receipt/fee-item-snippet])]
             :on-save       #(>evt [::save-fee-item group-id template-id %])
             :placeholders  fee-model/fee-item-snippet-variables
             :images        images
             :small?        true}
            (text-editor/with-external-edit-state ::item))]]]]))
